/* ============================================================================
   ENGORI — Glanz auf dem Warenkorb-Knopf
   CSS: engori-premium.css (.eng-sheen-el)

   Als eigenes Element statt ::before/::after, weil Shrine .button:before und
   .button:after bereits für eigene Hover-Effekte belegt.
   Nach Vorbild von Needed24.
   ========================================================================= */
(function () {
  'use strict';

  function anhaengen() {
    document.querySelectorAll('.product-form__submit').forEach(function (btn) {
      if (btn.querySelector('.eng-sheen-el')) return;
      /* Nur auf gefüllten Buttons — der sekundäre "Jetzt kaufen" bleibt schlicht */
      if (btn.classList.contains('button--secondary')) return;

      var el = document.createElement('span');
      el.className = 'eng-sheen-el';
      el.setAttribute('aria-hidden', 'true');
      el.appendChild(document.createElement('i'));
      btn.appendChild(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anhaengen);
  } else {
    anhaengen();
  }

  /* Theme-Editor und nachgeladene Sections */
  document.addEventListener('shopify:section:load', anhaengen);
  /* Nach Variantenwechsel baut Shrine den Kaufbereich neu auf */
  document.addEventListener('variant:change', anhaengen);
})();
